(ns manage.ad-variant-insights.tables.common
  (:require ["src/svg/artwork/table.svg$default" :as TableArtwork]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [common.util :as util]
            [uix.core :as uix :refer [$]]))

(defn format-ctr [value]
  (util/->locale-string value {:style "percent"
                               :maximumFractionDigits 3}))

(defn format-number [value]
  (util/->locale-string value))

(def NoRowsOverlay
  (uix/as-react
   (fn []
     ($ empty-state-view
        {:artwork TableArtwork
         :sx #js {:height "100%"}
         :title "No available data yet"
         :description "Your adset hasn’t received impressions yet. Once it starts generating activity, your analytics will populate automatically."}))))
